// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tg_tQPVYFPCzwmNt9ygt {
  position: relative;
}

.dcE_tbD8H_lIbOFpap0J {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

._tlB8a_TD6cTC7cC_fzv {
  display: flex;
  z-index: 1;
}

.c2p0ZCpeGrTWLCITkw9w {
  flex-basis: 100%;
  flex-shrink: 0;
  width: 100%;
}

.WYbC36vjigDtZr1uF2Fr {
  display: flex;
  align-items: center;
  grid-gap: 1rem;
  gap: 1rem;
  z-index: 0
}

.WYbC36vjigDtZr1uF2Fr.gLGbg1CtOEkspKfaWosW {
    display: flex;
    position: relative;
    top: initial;
    right: initial;
    width: 100%;
  }

.E52fflbguZbMhx230Fp_ {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none
}

.E52fflbguZbMhx230Fp_:first-of-type {
    margin-right: 1rem;
  }

.pfQu57YGohMVD9iSaSff {
  display: flex;
  width: 1.5rem;
  padding: 0;
  flex-shrink: 0;
  background: var(--white);
  border: none;
  cursor: pointer;
}

.h1C1MMY257NhksMyQ05L {
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 3rem;
}

.Z4UHpcQRFtZFCUySBsq7 {
  pointer-events: none;
}

.oKBT0gNs2YMPU22Fok7z {
  box-shadow: 0 0.25rem 0.75rem 0 var(--black-012);
}

.csNkJuWSLyi3_QeQlTaY {
  cursor: default;
  pointer-events: none;
}

@media only screen and
  (max-width: 639px) {
    .WYbC36vjigDtZr1uF2Fr.gLGbg1CtOEkspKfaWosW {
      grid-gap: 0;
      gap: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/EmblaSlider/EmblaSlider.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAS;EAAT,SAAS;EACT;AASF;;AAPE;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,WAAW;EACb;;AAGF;EACE,eAAe;EACf,yBAAiB;UAAjB;AAKF;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,aAAa;EACb,aAAW;EACX,UAAU;EACV,cAAc;EACd,wBAAwB;EACxB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAW;EACX,cAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gDAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;;IAEI;MACE,WAAM;MAAN,MAAM;IACR;AAEJ","sourcesContent":[".emblaWrapper {\n  position: relative;\n}\n\n.embla {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.emblaContainer {\n  display: flex;\n  z-index: 1;\n}\n\n.slideFullWidth {\n  flex-basis: 100%;\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  z-index: 0;\n\n  &.navWithThumbnails {\n    display: flex;\n    position: relative;\n    top: initial;\n    right: initial;\n    width: 100%;\n  }\n}\n\n.navIcon {\n  cursor: pointer;\n  user-select: none;\n\n  &:first-of-type {\n    margin-right: 16px;\n  }\n}\n\n.navButtonWrapper {\n  display: flex;\n  width: 24px;\n  padding: 0;\n  flex-shrink: 0;\n  background: var(--white);\n  border: none;\n  cursor: pointer;\n}\n\n.arrowWrapper {\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 48px;\n}\n\n.arrow {\n  pointer-events: none;\n}\n\n.arrowWrapperShadow {\n  box-shadow: 0 4px 12px 0 var(--black-012);\n}\n\n.disabled {\n  cursor: default;\n  pointer-events: none;\n}\n\n@media (--mobile) {\n  .nav {\n    &.navWithThumbnails {\n      gap: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emblaWrapper": `Tg_tQPVYFPCzwmNt9ygt`,
	"embla": `dcE_tbD8H_lIbOFpap0J`,
	"emblaContainer": `_tlB8a_TD6cTC7cC_fzv`,
	"slideFullWidth": `c2p0ZCpeGrTWLCITkw9w`,
	"nav": `WYbC36vjigDtZr1uF2Fr`,
	"navWithThumbnails": `gLGbg1CtOEkspKfaWosW`,
	"navIcon": `E52fflbguZbMhx230Fp_`,
	"navButtonWrapper": `pfQu57YGohMVD9iSaSff`,
	"arrowWrapper": `h1C1MMY257NhksMyQ05L`,
	"arrow": `Z4UHpcQRFtZFCUySBsq7`,
	"arrowWrapperShadow": `oKBT0gNs2YMPU22Fok7z`,
	"disabled": `csNkJuWSLyi3_QeQlTaY`
};
export default ___CSS_LOADER_EXPORT___;
